function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M806.088 170.857C716.136 90.821 399.593-72.73 191.898 55.389-26.602 190.172 1.713 617.317 41.648 695.178c49.919 97.327 192.755 194.654 437.406 249.494 244.651 54.839 374.836-172.585 444.819-346.821 56.1-139.67-27.832-346.959-117.785-426.994z",
  fill: "url(#project-backdrop_svg__paint0_linear)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M782.754 161.103C693.905 82.013 381.243-79.604 176.094 47-39.727 180.19-11.759 602.285 27.686 679.226 76.993 775.403 218.078 871.579 459.73 925.77c241.652 54.191 370.241-170.544 439.366-342.72 55.412-138.019-27.491-342.858-116.341-421.947z",
  fill: "url(#project-backdrop_svg__paint1_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "project-backdrop_svg__paint0_linear",
  x1: 417.836,
  y1: 260.849,
  x2: 439.677,
  y2: 945.104,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#807EE6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4B90D0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "project-backdrop_svg__paint1_linear",
  x1: 399.262,
  y1: 250.031,
  x2: 420.854,
  y2: 926.197,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#807EE6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4B90D0"
})));

function SvgProjectBackdrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 942 953",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOTQyIDk1MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC4yIiBkPSJNODA2LjA4OCAxNzAuODU3QzcxNi4xMzYgOTAuODIxMyAzOTkuNTkzIC03Mi43Mjk1IDE5MS44OTggNTUuMzg4N0MtMjYuNjAyMyAxOTAuMTcyIDEuNzEyOTMgNjE3LjMxNyA0MS42NDc4IDY5NS4xNzhDOTEuNTY2NSA3OTIuNTA1IDIzNC40MDMgODg5LjgzMiA0NzkuMDU0IDk0NC42NzJDNzIzLjcwNSA5OTkuNTExIDg1My44OSA3NzIuMDg3IDkyMy44NzMgNTk3Ljg1MUM5NzkuOTczIDQ1OC4xODEgODk2LjA0MSAyNTAuODkyIDgwNi4wODggMTcwLjg1N1oiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcikiLz4KPHBhdGggZD0iTTc4Mi43NTQgMTYxLjEwM0M2OTMuOTA1IDgyLjAxMzcgMzgxLjI0MyAtNzkuNjAzNiAxNzYuMDk0IDQ3Qy0zOS43MjczIDE4MC4xOSAtMTEuNzU5MiA2MDIuMjg1IDI3LjY4NjEgNjc5LjIyNkM3Ni45OTI3IDc3NS40MDMgMjE4LjA3OCA4NzEuNTc5IDQ1OS43MjkgOTI1Ljc3QzcwMS4zODEgOTc5Ljk2MSA4MjkuOTcgNzU1LjIyNiA4OTkuMDk1IDU4My4wNUM5NTQuNTA3IDQ0NS4wMzEgODcxLjYwNCAyNDAuMTkyIDc4Mi43NTQgMTYxLjEwM1oiIGZpbGw9InVybCgjcGFpbnQxX2xpbmVhcikiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjQxNy44MzYiIHkxPSIyNjAuODQ5IiB4Mj0iNDM5LjY3NyIgeTI9Ijk0NS4xMDQiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzgwN0VFNiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM0QjkwRDAiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDFfbGluZWFyIiB4MT0iMzk5LjI2MiIgeTE9IjI1MC4wMzEiIHgyPSI0MjAuODU0IiB5Mj0iOTI2LjE5NyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjODA3RUU2Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzRCOTBEMCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgProjectBackdrop as ReactComponent };